/** returns Customer Info
@return { Array }
*/
export const getCustomerInfo = state => {
    return state.customerInfo
}

/** returns Customer Contact Info
@return { Array }
*/
export const getCustomerContactsInfo = state => {
    return state.customerContactsInfo
}
